<template>
  <div class="wrapper-content border-radius border-gray-solid">
    <div class="options d-flex d-flex-just-beteween" style="align-items:center">
      <h5>Histórico de Projetos</h5>
      <div class="wrapper-status">
        <Select2
          v-model="ResumoHistoricoStatus"
          :options="Status"
          :settings="{  }"
          @select="ResumoHistoricoStatusSelect($event)"
        />
      </div>
      <Select2
        v-model="ResumoHistoricoAno"
        :options="Anos"
        :settings="{  }"
        @select="ResumoHistoricoAnoSelect($event)"
      />
    </div>
    <Loader v-if="!DadosCarregados" />

    <line-chart
      :chartData="ResumoAndamentoAnual"
      :options="optionsResumoAndamentoAnual"
      v-if="DadosCarregados"
      :height="'120'"
      chart-id="bar-ResumoAndamentoAnual"
    ></line-chart>
  </div>
</template>
<script>

import Select2 from "v-select2-component";
import LineChart from '../Components/LineChart.vue';
import axios from 'axios';

export default {
  props: ["Anos", "Status"],
  components:{
    Select2,
    LineChart
  },
  mounted() {
    this.fillData();
  },
  data() {
    return {
      DadosCarregados: false,
      ResumoHistoricoStatus: 0,
      ResumoHistoricoAno: 2019,
      ResumoAndamentoAnual: {
        datasets: [
          {
            backgroundColor: "transparent",
            borderJoinStyle: "bevel",
            lineTension: 0,
            borderColor: "rgb(240,230,140)",
            borderWidth: 1,
            pointBorderWidth: 1,
            pointBorderColor: "rgb(30,144,255)",
            pointBackgroundColor: "rgb(240,230,140)",
            data: null
          }
        ],
        labels: null,
      },
      optionsResumoAndamentoAnual: {
        animation : {
          duration : 0
        },
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 45,
            bottom: 20
          }
        },
        plugins: {
          datalabels: {
            color: "#021746",
            labels: {
              title: {
                align: "top"
              }
            }
          }
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              display: false,
              gridLines: {
                display: false
              }
            }
          ],
          xAxes: [
            {
              display: true,
              gridLines: {
                display: false
              }
            }
          ]
        }
      }
    };
  },
  methods: {
    ResumoHistoricoAnoSelect: function(val) {
      this.ResumoHistoricoAno = val.id;
      this.fillData();
    },
    ResumoHistoricoStatusSelect: function(val) {
      this.ResumoHistoricoStatus = val.id;
      this.fillData();
    },
    fillData: function() {
      let self = this;
      self.DadosCarregados = false;
      axios
        .get(
          this.$apiUrl +
            `Projeto.svc/dashboard/gestaoaldo/ProjetoStatusHistorico?ano=${self.ResumoHistoricoAno}&status=${self.ResumoHistoricoStatus}`
        )
        .then(function(response) {
         // console.log(response);
           self.ResumoAndamentoAnual.labels = response.data.labels;
           self.ResumoAndamentoAnual.datasets[0].data = response.data.Qtde;

           self.DadosCarregados = true;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>